import RecentBlog from "./RecentBlog";

export default RecentBlog;
